module.exports = __webpack_public_path__ + "img/hello-img.38631b26.png";